import frLang from './fr'
import enLang from './en'

export default {
  fr: frLang,
  en: enLang,
}

// Usage in views:
// - in React component: <Translate value="path.value"/>
// - in pure component : I18n.t('path.value')
// More infos: https://github.com/zoover/react-redux-i18n

// To create lang, create a xy.js file like en.js. Then import it like the fr and en above.
// Don't worry about the languages like en-US. Just name it en, it will be ok.
